import settingsPage from './settings.vue';
import penaltiesPage from './penalties/penalties.vue';
import architecturePage from './architecture/architecture.vue';
import architectureV2Page from './architecture/architecture-v2.vue';
import similarityGroupsPage from './similarity-groups/similarity-groups.vue';
import { settings as settingsPageIndex } from '@enums/page-index';
import {
  enableArchitectureV1,
  enableArchitectureLinePricingTabs,
  enableSimilarityGroups,
} from '@enums/feature-flags';

const routes = [
  {
    path: '/settings',
    name: 'settings',
    id: 'settings',
    component: settingsPage,
    linkText: 'linkText.settings',
    index: settingsPageIndex,
    children: [
      {
        path: 'penalties/workpackage/:workpackageId',
        name: 'penalties',
        id: 'penalties',
        component: penaltiesPage,
        linkText: 'linkText.penaltyRules',
        index: 0,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.penaltyRules',
        },
      },
      {
        path: 'architecture/workpackage/:workpackageId',
        name: 'architecture',
        id: 'architecture',
        component: architecturePage,
        linkText: 'linkText.architectureRules',
        index: 1,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.architectureRules',
          featureFlag: enableArchitectureV1,
        },
      },
      {
        path: 'architecture-v2/workpackage/:workpackageId',
        name: 'architecture-v2',
        id: 'architecture-v2',
        component: architectureV2Page,
        linkText: 'linkText.architectureRulesV2',
        index: 2,
        meta: {
          selectedWorkpackageRequired: true,
          title: 'tabText.architectureRulesV2',
          featureFlag: enableArchitectureLinePricingTabs,
        },
        children: [
          // Default route redirects to line-pricing-rules tab
          {
            path: '',
            redirect: to => ({
              name: 'line-pricing-rules',
              params: { workpackageId: to.params.workpackageId },
            }),
          },
          {
            path: 'architecture-rules',
            name: 'architecture-rules',
            index: 0,
            meta: {
              selectedWorkpackageRequired: true,
              title: 'tabText.architectureRules',
              featureFlag: enableArchitectureLinePricingTabs,
            },
          },
          {
            path: 'line-pricing-rules',
            name: 'line-pricing-rules',
            index: 1,
            meta: {
              selectedWorkpackageRequired: true,
              title: 'tabText.linePricingRules',
              featureFlag: enableArchitectureLinePricingTabs,
            },
          },
        ],
      },
      {
        path: 'similarity-groups/workpackage/:workpackageId',
        name: 'similarity-groups',
        id: 'similarity-groups',
        component: similarityGroupsPage,
        linkText: 'linkText.similarityGroups',
        index: 3,
        meta: {
          featureFlag: enableSimilarityGroups,
          selectedWorkpackageRequired: true,
          title: 'tabText.similarityGroups',
        },
      },
    ],
  },
];

export default routes;
